import { z } from 'my-zod'
import { notificationsModel } from './notifications-model'

export const notificationSystemView = notificationsModel.augment({
  sourceProfileName: z.string(),
  sourceProfileEmail: z.string()
})
export type notificationSystemView = z.infer<typeof notificationSystemView>
